import { AdminPanelSettingsRounded, Logout } from "@mui/icons-material";
import { Avatar, IconButton, ListItemIcon, MenuItem } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuPopup } from "../../layout";
import { Box } from "@mui/system";
import { Select } from "../../controls";
import { API, actions, endpoints } from "../../api/api";
import { AppContext } from "../../App";
import { useTranslation } from "react-i18next";

const Header = () => {
  const [profileEl, setProfileEl] = useState(null);
  const navigate = useNavigate();
  const { setBranch, authUser, branches, setBranches } = useContext(AppContext);
  const [branchVal, setBranchVal] = useState("");
  const { setAuthUser } = useContext(AppContext);
  const { t } = useTranslation();

  const handleProfile = (e) => {
    setProfileEl(e.currentTarget);
  };

  const handleLogout = () => {
    API(endpoints.Auth + actions.Logout).get(() => {
      setAuthUser();
      navigate("/auth");
    });
  };

  const handleChgBranch = (e) => {
    var branch = branches.find((j) => j.id === e.target.value);
    if (branch) {
      setBranch(branch);
      setBranchVal(branch.id);
    }
  };

  useEffect(() => {
    API(endpoints.Branch + actions.GetAuthUserBranches).get((res) => {
      if (res.status === 200) {
        setBranches([...res.result.map((j) => ({ ...j, label: j.name }))]);
        var _defBranch = res.result.find((j) => j.defBranch);
        if (_defBranch) {
          setBranch(_defBranch);
          setBranchVal(_defBranch.id);
        }
      }
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  return (
    <Box
      className="d-flex a-center w-100pr"
      sx={{ justifyContent: { md: "space-between", xs: "end" } }}
    >
      <Box
        className="ml-10 gray-color"
        sx={{
          display: { md: "block", xs: "none" },
        }}
      >
        <span>
          {t("Welcome")},&nbsp;
          <span className="fw-5">
            {authUser && authUser.firstName + " " + authUser.lastName}
          </span>
        </span>
      </Box>
      <div className="d-flex a-center">
        <div className="mr-10">
          <Select
            sx={{ minWidth: "150px" }}
            variant="outlined"
            size="small"
            name="hoa"
            fullWidth
            value={branchVal}
            onChange={handleChgBranch}
            options={branches}
          />
        </div>
        <div>
          <IconButton
            onClick={handleProfile}
            size="small"
            aria-controls="account-menu"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <Avatar
              alt="profile-pic"
              src={authUser.photo}
              className="bg-primary"
            />
          </IconButton>
          <MenuPopup
            anchorEl={profileEl}
            setAnchorEl={setProfileEl}
            id="account-menu"
          >
            <MenuItem onClick={() => navigate(`/user_form/${authUser.id}`)}>
              <ListItemIcon>
                <AdminPanelSettingsRounded fontSize="small" />
              </ListItemIcon>
              {t("MyAccount")}
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              {t("Logout")}
            </MenuItem>
          </MenuPopup>
        </div>
      </div>
    </Box>
  );
};

export default Header;
